<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  props: {
    value: {
      type: [Number, null] as PropType<string | number | null>,
      required: true,
    },
    min: {
      type: Number,
      required: false,
    },
    max: {
      type: Number,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:value'],
})
</script>

<template>
  <input
    v-bind="{ value, min, max }"
    class="border-darksilver h-8 rounded-sm border border-solid bg-white text-center text-sm font-bold disabled:opacity-50"
    type="number"
    placeholder="-"
    :disabled
    @input="
      (ev) =>
        $emit('update:value', Number((ev.target as HTMLInputElement).value))
    "
  />
</template>
